export default {
    namespaced: true,

    state: {
        popupEnabled: true,
    },

    getters: {
        /**
         * @param {object} state
         *
         * @returns {boolean}
         */
        popupIsEnabled(state) {
            return state.popupEnabled === true;
        },
    },

    mutations: {
        disablePopup(state) {
            state.popupEnabled = false;
        },

        enablePopup(state) {
            state.popupEnabled = true;
        },
    }
};
